import { render } from "./index.vue?vue&type=template&id=32741bb2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=32741bb2&scoped=true&lang=css"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32741bb2"]])

export default __exports__